import Home from '@/pages/Timeline'

export default {
  path: '/',
  name: 'Home',
  component: Home,
}


// WEBPACK FOOTER //
// ./src/router/home.js